// extracted by mini-css-extract-plugin
module.exports = {"container":"sourceanimation_container__37svd","sparepartsbase":"sourceanimation_sparepartsbase__ueqPM","nexts":"sourceanimation_nexts__3nQgZ"};